import { render, staticRenderFns } from "./BuyerDetailsStep4.vue?vue&type=template&id=9e614cf2&scoped=true"
import script from "./BuyerDetailsStep4.vue?vue&type=script&lang=js"
export * from "./BuyerDetailsStep4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e614cf2",
  null
  
)

export default component.exports